// Skill Levels
export const SKILL_LEVEL_MIN = 0 as const;
export const SKILL_LEVEL_FIRST = 1 as const; // first non-zero level
export const SKILL_LEVEL_REGULAR = 2 as const; // "regular" skill level
export const SKILL_LEVEL_ADVANCED = 3 as const; // minimal skill level considered as "advanced"
export const SKILL_LEVEL_TO_MENTOR = 3 as const; // minimal skill level to mentor others
export const SKILL_LEVEL_MAX = 4 as const;
export type SkillLevel = 0 | 1 | 2 | 3 | 4;
